<div class="modal-admin">
  <div class="header">
    <p class="close" (click)="close()"><img src="./assets/logos/close.svg" alt=""></p>
    <p class="title">{{data.title}}</p>
  </div>
  <div class="body">
    <div class="text-center">
      <p>
        {{data.message}}
      </p>
    </div>
    <div class="submit-button cancel">
      <button id="CANCEL" (click)="close()">{{data.cancel}}</button>
    </div>
    <div class="submit-button">
      <button id="OK" (click)="close(true)">{{data.accept}}</button>
    </div>

  </div>